import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { registerPWA } from "./lib/pwa-register";
import { toast } from "sonner";

registerPWA();

// Dedupe unhandled promise rejection logs to avoid console/toast spam when
// an async chunk or API call repeatedly fails (e.g. network, service worker
// returning HTML for script). We still log the first occurrence to aid
// debugging and show a single user-friendly toast.
const seenRejections = new Set<string>();
window.addEventListener("unhandledrejection", (event) => {
  try {
    const reason = (event as any).reason;
    const msg = reason && reason.message ? String(reason.message) : String(reason);
    const key = msg || String(reason);
    if (!seenRejections.has(key)) {
      seenRejections.add(key);
      console.error("Unhandled promise rejection:", reason, event);
      // Surface a generic, non-sensitive message to the user.
      toast.error("An internal error occurred. Try refreshing the page.");
    } else {
      // Silence duplicates.
    }
  } catch (err) {
    console.error("Error logging unhandled rejection", err);
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
